import styled from "styled-components";

export const Container = styled.div`
  padding: 10px;
  width: 100%;
  box-sizing: border-box;

  .timeline-banner {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #eaf6ff;
    border-radius: 30px;
    padding: 20px 40px;
    width: 100%;
    box-sizing: border-box;

    .step {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 10px;
      min-width: 150px;

      .step-icon-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;

        .icon-circle {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;

          i {
            font-size: 11px;
          }

          &.completed {
            background: white;
            color: #707582;
          }

          &.current {
            background: #1168ff;
            color: white;
            font-size: 13px;
          }
        }
      }

      .step-content {
        .title {
          font-size: 17px;
          color: #1f1f52;
        }

        .date-row {
          font-size: 14px;
          color: #707582;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 4px;

          .warning {
            color: #4a5568;
            display: flex;
            align-items: center;
            gap: 4px;

            strong {
              font-weight: 700;
            }

            i {
              color: #4a5568;
            }
          }
        }
      }
    }

    .gap-line {
      display: flex;
      align-items: center;
      flex: 1;
      max-width: 200px;
      margin: 0 15px;
      margin-top: -50px;

      .line {
        flex: 1;
        height: 3px;
        border-top: 3px dashed #ffffff;
      }

      .gap-text {
        font-size: 17px;
        color: #3e3e5b;
        margin: 0 10px;
      }
    }
  }
`;
